module.exports = __webpack_public_path__ + "7d96074dfb818c87b8a73480562f612a.png";